import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'langwithai',
    title: 'LangWithAI',
    description: 'LangWithAI is a language learning platform that uses AI to help users learn new languages. The platform offers a variety of features, including interactive lessons, vocabulary practice, and conversation practice with AI chatbots. Users can track their progress and receive personalized recommendations to help them improve their language skills.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
    },
};

export default data;
